import React from "react";

function Footer() {
  return (
    <footer className="fixed bottom-0 left-0 w-full bg-transparent border-t border-gray-700 py-4">
      <div className="text-center text-gray-400">
        © 2025 Ecklypce. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
